import PropTypes from 'prop-types';
import { useLocation, useMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from '@emotion/styled';

import { getUserFirstName } from 'dux/user/selectors';
import { getIsAuthenticated, getIsAuthenticating } from 'dux/auth/selectors';
import { consultationStepIsStandalone } from 'dux/consultation/selectors';

import Banner from 'Blocks/Banner';
import NavBar from 'Blocks/NavBar';
import ConsultationNavBar from 'Blocks/ConsultationNavBar';
import SkipLinkA11y from '../Components/SkipLinkA11y';

const HeaderContent = styled('header')`
  position: sticky;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: ${props => props.theme.zIndex.appBar};
`;

const Header = ({
  banner,
  hideNavbarCTA,
  isAuthenticated,
  isAuthenticating,
  isStandalone,
  showFooterLink,
  userName,
}) => {
  const { pathname } = useLocation();
  const match = useMatch('/:consultationType/*', pathname);
  const consultationType = match?.params?.consultationType;
  const consultationSubRoute = ['consultation', 'supplements-consultation', 'results'].includes(
    consultationType
  );
  const showConsultationNavBar = consultationSubRoute && !isStandalone;
  return (
    <HeaderContent>
      <SkipLinkA11y showFooterLink={showFooterLink} />
      {banner && <Banner />}
      {showConsultationNavBar ? (
        <ConsultationNavBar />
      ) : (
        <NavBar
          hideNavbarCTA={hideNavbarCTA}
          isAuthenticated={isAuthenticated}
          isAuthenticating={isAuthenticating}
          userName={userName}
        />
      )}
    </HeaderContent>
  );
};

Header.defaultProps = {
  banner: false,
  showFooterLink: false,
  hideNavbarCTA: false,
  userName: '',
};

Header.propTypes = {
  banner: PropTypes.bool,
  showFooterLink: PropTypes.bool,
  hideNavbarCTA: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  isAuthenticating: PropTypes.bool.isRequired,
  isStandalone: PropTypes.bool.isRequired,
  userName: PropTypes.string,
};

const mapStateToProps = state => ({
  isAuthenticated: getIsAuthenticated(state),
  isAuthenticating: getIsAuthenticating(state),
  isStandalone: consultationStepIsStandalone(state),
  userName: getUserFirstName(state),
});

export default connect(mapStateToProps)(Header);
